import script from "./ProfileRelationshipSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileRelationshipSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileRelationshipSelector.vue?vue&type=style&index=0&id=74d3dcf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d3dcf8"]])

export default __exports__